export default "__VITE_ASSET__BaRU0Ovj__"